import * as React from 'react';
import type { BlockedProductListEntry } from 'contracts/blocked-products';
import { isPrioritizedProductListEntry } from 'contracts/prioritized-products';
import { Table, TableHead, TableBody, TableCell, TableRow, TableHeader } from 'components/ui/table';
import { Formatter } from 'utils/Formatter';

import { PriorityIndicator } from './priority-indicator'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  products: BlockedProductListEntry[] | BlockedProductListEntry;
}

export const ProductsTable = ({ products, ...props }: Props) => {
  const productsArray = React.useMemo(() => {
    return Array.isArray(products) ? products : [products];
  }, [products]);

  return (
    <div {...props}>
      <Table>
        <TableHeader>
          <TableRow>
            {isPrioritizedProductListEntry(productsArray?.[0]) && (
              <TableHead>Prior.</TableHead>
            )}
            <TableHead>Vencimento</TableHead>
            <TableHead>Código</TableHead>
            <TableHead>Produto</TableHead>
            <TableHead>Motivo</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {productsArray.map(product => (
            <TableRow key={product.id}>
              {isPrioritizedProductListEntry(product) && (
                <TableCell>
                  <PriorityIndicator priority={product.priority} />
                </TableCell>
              )}
              <TableCell>{product.shelfLifeExpirationDate
                ? Formatter.date(product.shelfLifeExpirationDate)
                : '---'}
              </TableCell>
              <TableCell>{product.material}</TableCell>
              <TableCell>{product.materialDescription}</TableCell>
              <TableCell>{product.productReasonType?.description ?? '---'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};